import '/assets/styles/partials/badge.scss';
import classNames from 'classnames';

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';

export const Badge = ({
	children,
	className,
	variant = 'default',
	icon,
	big,
	small,
	outline,
	...props
}) => {
	return (
		<span
			{...props}
			className={classNames('badge', className, `variant-${variant}`, {
				big,
				small,
				outline,
				'icon-only': !children,
			})}
		>
			{icon && <Icon className="badge-icon" name={icon} />}
			{children && <span>{children}</span>}
		</span>
	);
};

export default Badge;
